<!-- 2022 世界杯游戏币版 -->
<template>
<div class="world-cup">
    <Header />
    <TopBanner :banner="banner" />
    <div class="container">
        <MyMoneyInfo ref="myinfo" />
        <Sponser @success="updateUserRecord" />
       <!--  <JoinTrends  ref="joinTrends" /> -->
        <div class="media-show">
            <div class="right-banner"><img src="https://media3.imgyb.xyz/media/v1/image/21e6051ebe909db03640b4f3b91c19fb.jpeg" alt=""></div>
            <Forecast />
        </div>
        <div class="cont-row g-grid">
            <div class="flex-cont ovhd">
                <Guessing @success="guessingDownSuccess" />
                <div class="media-show">
                    <Gamblers />
                    <OftenWin />
                </div>
                <div class="post-subject">
                    <div class="head-title cont-row">
                        <div class="flex-cont head-text"><strong>相关话题</strong></div>
                        <div class="tab cont-row">
                            <div class="item" :class="{active:type=='forum'}" @click="typeChange('forum')">帖子</div>
                            <div class="item" :class="{active:type=='cms'}"  @click="typeChange('cms')">新闻</div>
                        </div>
                    </div>
                    <template v-for="(item,index) in list" >
                        <div class="flow-ad-content" :key="index" v-if="item.app === 'crm_ad'"><YorkbbsInfoflowItem  :data="item" :key="index" class="mrg-btm20"></YorkbbsInfoflowItem></div>
                        <ItemSubject v-else-if="type=='forum'" :data="item" :key="item.id" />
                        <CmsItemPost v-else-if="type=='cms'" :data="item" :key="item.id" />
                    </template>

                    <div class="loading-style" v-if="hasMore && listLoading " ><i class="el-icon-loading"></i> 加载中</div>
                </div>
            </div>
            <div class="rank-list full-show">
                
                <div class="right-banner"><img src="https://media3.imgyb.xyz/media/v1/image/21e6051ebe909db03640b4f3b91c19fb.jpeg" alt=""></div>
                <Forecast />
                
                <Gamblers />
                <OftenWin />
            </div>
        </div>
    </div>
    <CssFooter></CssFooter> 


</div>
</template>
<script>
import Header from '@/components/header/header.vue'
import TopBanner from '@/components/widgets/top-banner.vue'
import MyMoneyInfo from './components/my-money-info.vue'
import Sponser from './components/sponser.vue'
/* import JoinTrends from './components/join-trends.vue' */
import Forecast from './components/forecast.vue'
import Gamblers from './components/gamblers.vue'
import OftenWin from './components/often-win.vue'
import Guessing from './components/guessing.vue'
import { throttle } from 'throttle-debounce';
import { isScrollToPageBottom ,inflowAdvConvert} from '@/utils/utils';
import YorkbbsInfoflowItem from '@/components/item-infoflow.vue'
import ItemSubject from './components/item-subject.vue'
import CssFooter from '@/components/css-footer.vue'
import CmsItemPost from '@/components/cms-item-post.vue'
export default {
    name:'WorldCupCurrency2022',
    components:{Header,TopBanner,MyMoneyInfo,Sponser,Forecast,Gamblers,OftenWin,Guessing,YorkbbsInfoflowItem,ItemSubject,CssFooter,CmsItemPost},
    data(){
        return {
            banner:{
                pcBanner:'https://media5.imgyb.xyz/media/v1/image/d0e0535d58ee0c8d8979818c63dab918.png',
                pcBannerBg:'https://media7.imgyb.xyz/media/v1/image/bbd0fbee3c3032fd045960724cb60f05.png',
                mBanner:'https://media2.imgyb.xyz/media/v1/image/fd4b21302417fd8c84fa88b2d7a919f2.png',
            },
            type:'forum',
            forumParams:{   
                "offset": 1,
                "size": 10,
                //"sort": ["property_thumbUpTotal: DESC","property_updatedAt: DESC"],
                //"sort":['property_top: DESC','property_commentedAt: DESC'],
                "sort":['property_commentedAt: DESC'],
                "subject": [
                    "375c9588-c944-424a-9f02-29540dfcf364"
                ],
                //"options":{"elite":[1]},    
            },
            cmsParams:{
                offset:1,
                size:10,
                keyword:'世界杯'
            },
            list:[],
            pageComplete:false,
            hasMore:true,
            listLoading:true,
        }
    },
    created(){
        this.getList();
        
    },
     mounted() {
        window.addEventListener('scroll', this.pageScroll);

        this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('scroll', this.pageScroll);
        });
    },
    methods:{
        pageScroll: throttle(300, function () {
            if( isScrollToPageBottom() && this.pageComplete && this.hasMore && !this.listLoading ){
                if( this.type == 'forum'){
                    this.forumParams.offset ++;
                }else{
                    this.cmsParams.offset ++;
                }
               
                this.getList();
            }
            
        }),
        typeChange(index){
            if( this.type == index) return false;
            this.type = index;
            if( this.type == 'forum'){
                this.forumParams.offset = 1;
            }else{
                this.cmsParams.offset = 1;
            }
          
            this.list = [];
            this.getList();
  
        },
        async getList(){
            let url = '/bbs/v1/get/post/list/for/subject';
            let sendData ={};
            if( this.type == 'cms'){
                url = '/cms/v1/get/subject/list/data';
                sendData = {...this.cmsParams}
            }else{
                sendData = {...this.forumParams}
            }
           
            
            this.listLoading = true;
            let result = await this.$axios.post(url,sendData);
            this.pageComplete = true;
            this.listLoading = false;
           
            if( result.code == 0 ){
                
                if( this.type =='forum' && this.forumParams.offset == 1 ){
                    this.list = [];
                }
                if( this.type =='cms' && this.cmsParams.offset == 1 ){
                    this.list = [];
                }
                var inflowAdv = inflowAdvConvert(result.data.items, 'topic', '3261');
                this.list = this.list.concat(inflowAdv);
                console.log(this.list)
                if( this.type =='forum'){

                    this.hasMore = this.forumParams.offset < result.data.pageTotal;
                }
                if( this.type == 'cms'){
                    this.hasMore = this.cmsParams.offset < result.data.pageTotal;
                }
            }
        },
        //更新用户信息
        updateUserRecord(){
            
            this.$refs['myinfo'].getUserRecord();
        },
        //竞猜成功了
        guessingDownSuccess(){
            this.$refs['myinfo'].getUserRecord();
            //this.$refs['joinTrends'].getList();
        }
    }


}
</script>
<style lang="less" scoped>
.world-cup{background: #f8f8f8;}
.container{width:1170px; margin:0 auto; }
.rank-list{width:340px; margin-left: 30px;}
.g-grid{align-items: flex-start;}
.full-show{display: block;}
.media-show{display: none;}
.right-banner{
    img{display: block; width: 100%;}
}
@media screen and (min-width:768px){
    .world-cup{min-width:1200px; }
}
@media screen and (max-width:768px){
    .world-cup{width:100%}
    .container{width:100%; padding:  0 10px; box-sizing: border-box;}
    .full-show{display: none;}
    .media-show{display: block;}

    .g-grid{
        flex-direction: column;
        .rank-list{width:100%; margin-left: 0;}
    }
}

.post-subject{
    padding: 20px 30px; background: #fff; border-radius: 10px;
    .head-title{
        margin-bottom: 30px;
        .tab{
            .item{
                font-size: 16px; color: #111;  margin-left: 20px; cursor: pointer; opacity: 0.7;
                &.active{font-weight: bold ; opacity: 1;}
            }
        }
    }
    
}

.loading-style{display: flex; margin-bottom: 20px; color: #999; justify-content: center ; align-items: center; font-size: 12px;
    i{margin-right: 5px;}
}
@media screen and (max-width:768px) {
    .post-subject{
        padding: 15px;margin-top:20px;
        .head-title{
            margin-bottom: 20px;
        }
        .flow-ad-content{
            border-bottom: 1px solid #eee; padding-left: 46px;
        }
    }
}
</style>